// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__lGBbh","icon":"styles_icon__mDlam"};